import { api } from './client'
import type { EstimatesReport } from './types'

// Indexable so it slots straight into ApiClient.get's params type without a cast.
export interface EstimatesReportParams {
  [key: string]: string | undefined
  /** ISO-8601 inclusive lower bound on `estimate.createdAt`. */
  startDate?: string
  /** ISO-8601 inclusive upper bound on `estimate.createdAt`. */
  endDate?: string
}

export const reportingApi = {
  /**
   * Fetch the aggregated estimates report for a team. Group teams roll up
   * across every child dealership; bodyshop teams come back without per-user
   * breakdowns. Both `startDate`/`endDate` are optional — omit both for
   * all-time totals.
   */
  estimatesReport: (
    teamId: number | string,
    params?: EstimatesReportParams,
  ) =>
    api.get<EstimatesReport>(`/reporting/estimates/team/${teamId}`, params),
}
